import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';

import {DeleteDialogComponent, DeleteDialogProps} from '../dialog/delete-dialog.component';

export type RelativeDeleteDialog = Pick<DeleteDialogProps, 'open' | 'onCancel' | 'onConfirm'>;

function RelativeDeleteDialog(props: RelativeDeleteDialog) {
  const {t} = useTranslation();
  return (
    <DeleteDialogComponent
      {...props}
      title={t('relative-delete-warning-modal.header')}
      contentText={t('relative-delete-warning-modal.body')}
    />
  );
}

export const RelativeDeleteDialogComponent = memo(RelativeDeleteDialog);
